export const shippingLabelStatusValues = {
  pending: 'pending',
  created: 'created',
}

export const shippingLabelStatus = [
  {
    label: 'Pendientes',
    value: shippingLabelStatusValues.pending,
  },
  {
    label: 'Creadas',
    value: shippingLabelStatusValues.created,
  },
]
